import * as moment from 'jalali-moment';
// const date = new Date();
// const value = Number(moment.unix(date.getTime() / 1000).locale('fa').format('YYYY'));
export class DatePickerShamsi {
  caption: string;
  calendarCaption: string;
  startYaer?: number;
  count?: number;
  middle?: boolean;
  calendarPickerStyle: {
    width?: string,
    background?: string,
    borderRadius?: string,
    padding?: string,
  } = {};
  constructor(config?) {
    this.caption = config?.caption || 'از تاریخ';
    this.calendarCaption = config?.calendarCaption || 'نوشتن با تقویم';
    this.calendarPickerStyle.width = config?.calendarPickerStyle?.width || '27%';
    this.calendarPickerStyle.background = config?.calendarPickerStyle?.background || '#e4e1e6';
    this.calendarPickerStyle.borderRadius = config?.calendarPickerStyle?.borderRadius || '10px';
    this.calendarPickerStyle.padding = config?.calendarPickerStyle?.padding || '5px 10px';
    this.startYaer = config?.startYaer;
    this.count = config?.count || 10;
    this.middle = config?.middle || false;
  }

}
